import { render, staticRenderFns } from "./LoadCancellation.vue?vue&type=template&id=dbdcbd34&scoped=true"
import script from "./LoadCancellation.vue?vue&type=script&lang=js"
export * from "./LoadCancellation.vue?vue&type=script&lang=js"
import style0 from "./LoadCancellation.vue?vue&type=style&index=0&id=dbdcbd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdcbd34",
  null
  
)

export default component.exports